import styled from "@mui/material/styles/styled";

import Stack, { Row } from "@rui/Stack";

export const RecapChartWrapper = styled(Stack)(({ theme }) => ({
  flexGrow: 1,
  minWidth: 0,
  overflow: "hidden",
  [theme.breakpoints.down("sm")]: {
    alignItems: "center",
  },
}));

export const ChartsWrapper = styled(Row)(({ theme }) => ({
  width: "100%",
  maxWidth: "100%",
  paddingBottom: theme.spacing(2),
  padding: theme.spacing(1),
  border: "1px solid",
  borderColor: theme.palette.shades.neutral[100],
  borderRadius: theme.corners.base,
  marginBottom: theme.spacing(2),
  gap: theme.spacing(1),

  "& .recap-charts__divider": {
    color: theme.palette.shades.neutral[50],
  },
  [theme.breakpoints.up("sm")]: {
    padding: theme.spacing(1.5, 2),
    marginBottom: theme.spacing(1),
    border: "none",
    gap: theme.spacing(2),
    "& .recap-charts__divider": {
      display: "none",
    },
  },
  [theme.breakpoints.up("mobile")]: {
    padding: 0,
    paddingBottom: theme.spacing(1),
  },
}));
